import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  createUrlTreeFromSnapshot,
  Router,
} from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { WebPortalService } from '../../services/web-portal/web-portal.service';
import { MainRoutes } from '../guard.models';
import { PAROwnerService } from './../../modules/planning-department/planning-act-request/services/owner/owner.service';

@Injectable({
  providedIn: 'root',
})
export class PlanningActCurrentStateGuard implements CanActivate {
  private path: MainRoutes;

  constructor(
    private parOwnerService: PAROwnerService,
    private webPortalService: WebPortalService,
    private translateService: TranslateService,
    private toastr: ToastrService,
    private router: Router,
  ) {}

  canActivate(routeSnapshot: ActivatedRouteSnapshot): Observable<boolean> {
    this.path = this.getParentRoutePath(routeSnapshot);
    const urlTree = createUrlTreeFromSnapshot(routeSnapshot, [
      '../requests-list',
    ]);
    const messageTranslationKey: string =
      routeSnapshot.data?.['noOwnerMessageTranslationKey'];

    return this.webPortalService.getWebPortalDataByCurrentRoute(this.path).pipe(
      switchMap((webPortal) => this.parOwnerService.get(webPortal.portalId)),
      switchMap((owner) => {
        if (!owner?.length) {
          this.router.navigateByUrl(urlTree);
          this.showMessage(messageTranslationKey);

          return of(false);
        }

        return of(true);
      }),
    );
  }

  showMessage(messageTranslationKey: string): void {
    this.translateService.get(messageTranslationKey).subscribe((message) => {
      this.toastr.warning(message, null, {
        timeOut: 0,
        extendedTimeOut: 0,
        closeButton: true,
      });
    });
  }

  getParentRoutePath(route: ActivatedRouteSnapshot): MainRoutes {
    const parentUrlSegments = route.parent?.url || [];
    const parentUrl = parentUrlSegments
      .map((segment) => segment.path)
      .join('/');

    return parentUrl as MainRoutes;
  }
}
